import { render, staticRenderFns } from "./SignRecord.vue?vue&type=template&id=71d3240c&"
import script from "./SignRecord.vue?vue&type=script&lang=js&"
export * from "./SignRecord.vue?vue&type=script&lang=js&"
import style0 from "./SignRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports